"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const poll_1 = __importDefault(require("src/redux/sagas/root/poll"));
const survey_1 = __importDefault(require("src/components/survey"));
const app_1 = __importDefault(require("src/components/app/app"));
const pages_1 = __importDefault(require("src/components/pages"));
const progress_bar_default_1 = __importDefault(require("src/components/progress-bar/progress-bar-default"));
const with_template_1 = __importDefault(require("src/components/with-template"));
const page_1 = __importDefault(require("src/components/page"));
const common_styles_1 = __importDefault(require("./common.styles"));
const PageWithTemplating = (0, with_template_1.default)(page_1.default);
function PollDefault({ surveyConfig, location, size, rootService }) {
    return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: common_styles_1.default }), (0, jsx_runtime_1.jsx)(survey_1.default, { size: size, surveyConfig: surveyConfig, location: location, rootService: rootService, AppComponent: app_1.default, PageComponent: PageWithTemplating, PagesComponent: pages_1.default, rootSaga: poll_1.default, ProgressBarComponent: progress_bar_default_1.default })] }));
}
exports.default = PollDefault;
